<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>
      <SubHeaderWithSidebar :title="headerTitle" />
      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <!-- 

                통계화면시
                check 클래스 추가
          -->
          <div class="quizWrap check">
            <h5 class="subtitle">
              Poll
              <span>{{itemIndex}}</span>
            </h5>

            <!-- p283 경우 -->
            <div class="quiz first">
              <h3 class="quizTitle">{{itemTitle}}</h3>

              <div class="ex_checkWrap" v-bind:key="bogi.id" v-for="bogi in bogis">
                <div class="ex_check">
                  <!--top class-->
                  <div class="stat" :class="bogi.top">
                    <div class="num">{{bogi.index}}</div>
                    <div class="stat_head">
                      <div class="text">{{bogi.title}}</div>
                      <div class="img" v-if="bogi.image != null">
                        <img :src="bogi.image.url" alt />
                      </div>
                    </div>
                    <div class="stat_body">
                      <div class="per">{{bogi.per}}%</div>
                      <div class="progress">
                        <span class="img">
                          <img src="@/assets/img/best.png" alt="BEST" />
                        </span>
                        <span class="bar" :style="bogi.perstyle"></span>
                      </div>
                      <div class="people">
                        <span>{{bogi.count}}</span> 명
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ex_check -->
              </div>
              <!-- ex_checkWrap -->

              <!-- ex_checkWrap -->
            </div>
            <!-- survey -->
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import sideMixin from "@/components/SideMixin";
import * as R from "ramda";

export default {
  mixins: [sideMixin],
  components: { SubHeaderWithSidebar },
  computed: {
    bogiStyle() {
      let bogi_deco = this.$store.state.itemMeta.bogi_deco;
      return bogi_deco === "text" ? "exampleWrap text_ex" : "exampleWrap";
    },
    bogis() {
      let details = this.$store.getters.getItemMeta.details;
      let stats = this.$store.state.itemMeta.stats;

      let sum = 0;
      let max = 0;
      R.forEach(x => {
        sum += x.count;
        if (x.count > max) max = x.count;
      }, stats);

      // console.log(stats);

      // let answer = this.$store.state.itemMeta.answer;
      details.forEach((item, index) => {
        item.kid = "example1_" + (index + 1);
        item.style = "example"; // example , example checked
        for (var i = 0; i < stats.length; i++) {
          if (item.id === stats[i].detail_id) {
            item["count"] = stats[i].count;
            let _t = Math.round((stats[i].count / sum) * 100, 2);
            if (isNaN(_t)) _t = 0;
            item["per"] = _t;
            item["top"] =
              stats[i].count === max && stats[i].count !== 0 ? "top" : "";
            item["perstyle"] = "width:" + _t + "%;";
          }
        }

        item.style = "example"; // example , example checked
      });
      console.log(details);
      return details;
    },
    odd() {
      let bogi_deco = this.$store.state.itemMeta.bogi_deco;
      let details = this.$store.getters.getItemMeta.details;
      return details.length % 2 === 0 || bogi_deco === "text" ? false : true;
    },
    itemIndex() {
      return this.$store.state.itemMeta.index;
    },
    itemTitle() {
      return this.$store.state.itemMeta.title;
    },

    headerTitle() {
      return this.$store.state.itemMeta.item_type === "quiz"
        ? "Live Quiz"
        : "Live Poll";
    }
  }
};
</script>


<style lang="scss" scoped>
</style>